import BeneficiaryList from './BeneficiaryList'

export default BeneficiaryList



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/components/Beneficiary/index.js